<template>
  <div class="detail">
    <video-player
      :baseUrl="curData.baseUrl"
      :videoUrl="curData.videoUrl"
      :title="curData.title"
      :setNum="curData.setNum"
      :num="curData.num"
      :videoFormat="curData.videoFormat"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>

      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";

export default {
  name: "ScienceDetail",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      pageData: {
        1: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/monkeych/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/monkeych/1.mp4",
          title: "小猴语文",
          setNum: 49,
          videoFormat: "mp4",
          num: "1",
        },
        2: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/monkeyai/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/monkeyai/1.mp4",
          title: "小猴AI启蒙课",
          setNum: 25,
          videoFormat: "mp4",
          num: "1",
        }
      },
      curData: {},
      rankingList: [
        { title: "小猴语文", views: "230", path: "/monkeyDetail", id: 1 },
        { title: "小猴AI启蒙课", views: "30", path: "/monkeyDetail", id: 2 }
      ],
    };
  },
  watch: {
    $route: {
      handler() {
        const pageId = this.$route.query.id;
        this.curData = this.pageData[pageId];
      },
      deep: true,
    },
  },
  created() {
    const pageId = this.$route.query.id;
    this.curData = this.pageData[pageId];
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>


